/* tslint:disable */

declare var Object: any;
export interface FeedBackInterface {
  "email": string;
  "subject": string;
  "message": string;
  "id"?: number;
}

export class FeedBack implements FeedBackInterface {
  "email": string;
  "subject": string;
  "message": string;
  "id": number;
  constructor(data?: FeedBackInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FeedBack`.
   */
  public static getModelName() {
    return "FeedBack";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FeedBack for dynamic purposes.
  **/
  public static factory(data: FeedBackInterface): FeedBack{
    return new FeedBack(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FeedBack',
      plural: 'FeedBacks',
      path: 'FeedBacks',
      properties: {
        "email": {
          name: 'email',
          type: 'string'
        },
        "subject": {
          name: 'subject',
          type: 'string'
        },
        "message": {
          name: 'message',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FeedBack.ts